import { Injectable } from '@angular/core';
import { SplunkRum } from '@nodeModules/@splunk/otel-web';
import { Version } from '../../../environments/app-version';
import { AppConfigService } from '../../services/appConfig/appConfigService';
import { TimberService } from '@logging/timber.service';

/*
 * Service to help manage Splunk RUM (Real User Monitoring) inside microfrontends.
 * We'd like to see all RUM data of microfrontends in the separate dashboards in Splunk.
 * However, SplunkRum is designed as a singleton and it attaches itself to the global window object.
 * This service helps to initialize and deinitialize SplunkRum when microfrontend is loaded and unloaded.
 */
@Injectable({
	providedIn: 'root',
})
export class SplunkHelperService {
	private readonly GLOBAL_OPENTELEMETRY_API_KEY = Symbol.for('opentelemetry.js.api.1');
	private isInited = false;

	private originalRumData: any = null;
	constructor(
		private readonly appConfigService: AppConfigService,
		private timberService: TimberService
	) {}

	init() {
		try {
			const { signalFx } = this.appConfigService.appSettings;

			if (!signalFx.isEnabled && SplunkRum.inited) {
				SplunkRum.deinit();
			}

			if (signalFx.isEnabled && !SplunkRum.inited) {
				SplunkRum.init({
					realm: signalFx.realm,
					rumAccessToken: signalFx.rumAuth,
					applicationName: signalFx.app,
					deploymentEnvironment: signalFx.environment,
					version: Version.version,
				});
				this.originalRumData = globalThis[this.GLOBAL_OPENTELEMETRY_API_KEY];
				this.isInited = true;
			}
		} catch (error) {
			this.timberService.error('Failed to initialize SplunkRum:', { module: 'SplunkHelperService', error });
		}
	}

	deinit() {
		if (SplunkRum.inited) {
			SplunkRum.deinit();
			this.isInited = false;
			this.originalRumData = null;
		}
	}

	removeOriginalMonitoring(): any {
		const openApi = globalThis?.[this.GLOBAL_OPENTELEMETRY_API_KEY];

		if (openApi) {
			delete globalThis[this.GLOBAL_OPENTELEMETRY_API_KEY];
		}
	}

	restoreOriginalMonitoring(): void {
		if (this.isInited && this.originalRumData !== null && globalThis) {
			globalThis[this.GLOBAL_OPENTELEMETRY_API_KEY] = this.originalRumData;

			this.isInited = false;
			this.originalRumData = null;
		}
	}
}
